export const CAMPAIGN_TYPE_URL_SECTION = ':type';

export const CAMPAIGN_ID_URL_SECTION = ':id';

export const STEP_URL_SECTION = ':step';

export const STEP_ROUTE_PATH = `/campaigns/${CAMPAIGN_TYPE_URL_SECTION}/${CAMPAIGN_ID_URL_SECTION}/step/${STEP_URL_SECTION}`;
